import React from "react";
import { useEffect, useState } from "react";
import { ref, onValue } from "firebase/database";
import { database } from "../../firebaseConfig";
import "react-datepicker/dist/react-datepicker.css";

const Notification = () => {
  const threeDaysAgo = new Date();
  threeDaysAgo.setDate(threeDaysAgo.getDate() - 1);

  const [notifications, setNotifications] = useState([]);
  const [filteredNotis, setFilteredNotis] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");

  useEffect(() => {
    const fetchNotifications = async () => {
      try {
        const notificationsRef = ref(database, "Notifications");
        onValue(notificationsRef, (snapshot) => {
          const data = snapshot.val();
          if (data) {
            // Convert object to array and filter for the last day's notifications
            let notificationsList = Object.keys(data)
              .map((key) => ({ id: key, ...data[key] }))
              .filter(
                (notification) => notification.time >= threeDaysAgo.getTime()
              ) // Keep only last 24 hours
              .sort((a, b) => b.time - a.time);

            // If no notifications from the last day, take the latest 50
            if (notificationsList.length === 0) {
              notificationsList = Object.keys(data)
                .map((key) => ({ id: key, ...data[key] }))
                .sort((a, b) => b.time - a.time)
                .slice(0, 50); // Get the latest 50 notifications
            }

            setNotifications(notificationsList);
            setFilteredNotis(notificationsList);
          } else {
            setNotifications([]);
          }
        });
      } catch (error) {
        console.error("Error fetching notifications:", error);
      }
    };

    fetchNotifications();
  });

  // // Fetch Notifications...
  // useEffect(() => {
  //   const fetchNotifications = async () => {
  //     try {
  //       const notificationsRef = ref(database, "Notifications");
  //       onValue(notificationsRef, (snapshot) => {
  //         const data = snapshot.val();
  //         if (data) {
  //           // Convert the data into an array or process it as needed
  //           const notificationsList = Object.keys(data)
  //             .map((key) => ({ id: key, ...data[key] }))
  //             .sort((a, b) => b.time - a.time);
  //           setNotifications(notificationsList);
  //           setFilteredNotis(notificationsList);
  //         } else {
  //           setNotifications([]);
  //         }
  //       });
  //     } catch (error) {
  //       console.error("Error fetching notifications:", error);
  //     }
  //   };

  //   fetchNotifications();
  // }, [startDate, endDate]);

  const formatDate = (timestamp) => {
    const date = new Date(timestamp);
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const ampm = hours >= 12 ? "PM" : "AM";
    const formattedHours = hours % 12 || 12; // Convert 0 to 12 for 12-hour format
    const formattedMinutes = minutes < 10 ? "0" + minutes : minutes;
    const timeString = `${formattedHours}:${formattedMinutes} ${ampm}`;
    const dateString = date.toLocaleDateString("en-GB").replace(/\//g, "-"); // Format date as DD-MM-YYYY
    return { time: timeString, date: dateString };
  };

  //Search Filter...
  useEffect(() => {
    if (searchQuery.trim() === "") {
      setFilteredNotis(notifications); // Reset to full list when search is empty
    } else {
      const filtered = notifications.filter((visit) =>
        visit.user?.name?.toLowerCase().includes(searchQuery.toLowerCase())
      );
      setFilteredNotis(filtered);
    }
  }, [searchQuery, notifications]); // Depend on `notifications` too

  return (
    <div className="p-8 bg-lightgray h-full overflow-y-scroll">
      <div className="flex flex-col md:flex-row justify-between items-center">
        <h2 className="text-2xl font-semibold mb-4 md:mb-0 font-lato w-fit">
          Notifications ({filteredNotis.length})
        </h2>
        <div className="flex gap-2"></div>
      </div>

      <div className="max-w-full mx-auto mt-4 bg-white p-6 rounded-lg shadow-lg">
        {/* Sticky Header Section */}
        <div className="flex justify-between items-center mb-6 lg:sticky top-0 bg-white p-4 z-10">
          <input
            type="text"
            placeholder="Search User Name"
            className="w-full md:w-auto border border-gray-300 rounded-lg px-4 py-2"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </div>

        {/* Notification Content */}
        <div>
          {filteredNotis.map((notification) => {
            const { time, date } = formatDate(notification.time);
            return (
              <div
                key={notification.id}
                className="bg-white p-4 shadow-lg rounded-lg mb-4"
              >
                <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center">
                  <div className="flex flex-col sm:mb-0 mb-4">
                    <p className="font-semibold text-lg font-lato">
                      {notification?.user?.name}
                    </p>
                    <p className="text-liquidblue font-lato">
                      {notification?.user?.phone}
                    </p>
                  </div>
                  <div className="flex justify-center sm:mt-0 mt-4 sm:mb-0 mb-4">
                    <p className="text-green-700 text-3xl font-bold">
                      {notification.progress}%
                    </p>
                  </div>
                  <div className="flex items-center sm:mt-0 mt-4">
                    <p className="text-darkteal font-lato font-bold">
                      {notification?.user?.territory?.name}
                    </p>
                  </div>
                </div>
                <p className="text-black font-lato mt-2 font-semibold">
                  {notification.info}
                </p>
                <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mt-2">
                  <div className="flex flex-col sm:justify-end items-center mb-2 sm:mb-0">
                    <p className="text-gray-400 text-sm mt-2 font-lato">
                      {time}
                    </p>
                    <p className="text-gray-400 text-sm mt-2 font-lato">
                      {date}
                    </p>
                  </div>
                  <p className="text-gray-400 font-lato font-semibold">
                    {notification?.user?.zone}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Notification;
